import React, { useState, useEffect } from 'react';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, TextField, TablePagination, Typography
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { useApi } from '../../contexts/Apicontext';

const TagsTable = () => {
    const [tags, setTags] = useState([]);
    const [openAddDialog, setOpenAddDialog] = useState(false);
    const [newTag, setNewTag] = useState({ tagName: '' });
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const navigate = useNavigate();
    const apiBaseUrl = useApi();

    useEffect(() => {
        fetchTags();
    }, []);

    const fetchTags = async () => {
        const token = localStorage.getItem('token');
        const response = await fetch(`${apiBaseUrl}/admin/tags`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        const data = await response.json();
        setTags(data);
    };

    const handleOpenAddDialog = () => {
        setOpenAddDialog(true);
    };

    const handleCloseAddDialog = () => {
        setOpenAddDialog(false);
        setNewTag({ tagName: '' });
    };

    const handleAddTag = async () => {
        const token = localStorage.getItem('token');
        const response = await fetch(`${apiBaseUrl}/admin/tags`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(newTag)
        });

        if (response.ok) {
            Swal.fire('Added!', 'New tag has been added.', 'success');
            handleCloseAddDialog();
            fetchTags();
        } else {
            Swal.fire('Error!', 'Failed to add new tag.', 'error');
        }
    };

    const handleDeleteClick = async (tagID) => {
        const firstConfirmation = window.confirm('Are you sure you want to delete this tag? This action cannot be undone.');

        if (firstConfirmation) {
            const secondConfirmation = window.confirm('This is a permanent action. Are you absolutely sure you want to delete this tag?');

            if (secondConfirmation) {
                const token = localStorage.getItem('token');
                const response = await fetch(`${apiBaseUrl}/admin/tags/${tagID}`, {
                    method: 'DELETE',
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });

                if (response.ok) {
                    alert('Deleted! Tag has been deleted.');
                    fetchTags();
                } else {
                    alert('Error! Failed to delete tag.');
                }
            }
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewTag({ ...newTag, [name]: value });
    };

    const handleViewDetailedTag = (tagID,tagName) => {
        navigate(`/admin/tags/${tagID}/detailed`, { state: { tagID, tagName } });
    };

    return (
        <div className='w-full'>
            <Typography variant="h4" gutterBottom>
                Tags Management
            </Typography>
            <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={handleOpenAddDialog} sx={{ mb: 2 }}>
                Add New Tag
            </Button>
            <TableContainer component={Paper} sx={{ width: '100%' }}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Tag ID</TableCell>
                            <TableCell>Tag Name</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tags.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((tag) => (
                            <TableRow key={tag.tagID}>
                                <TableCell>{tag.tagID}</TableCell>
                                <TableCell>{tag.tagName}</TableCell>
                                <TableCell>
                                    <IconButton onClick={() => handleViewDetailedTag(tag.tagID,tag.tagName)}>
                                        <VisibilityIcon />
                                    </IconButton>
                                    <IconButton onClick={() => handleDeleteClick(tag.tagID)}>
                                        <DeleteIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                component="div"
                count={tags.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />

            <Dialog open={openAddDialog} onClose={handleCloseAddDialog} fullWidth maxWidth="sm">
                <DialogTitle>Add New Tag</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Enter the details of the new tag.
                    </DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        name="tagName"
                        label="Tag Name"
                        value={newTag.tagName}
                        onChange={handleInputChange}
                        fullWidth
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseAddDialog} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleAddTag} color="primary">
                        Add
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default TagsTable;
